module.exports = __webpack_public_path__ + "static/media/Poll.90584647.svg";